import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import Drawer from "../../images/filing-cabinet/cabinet_drawer.png";

export default class CabinetSwitcherPopup extends Component {
  render() {
    const { isOpen, onClose } = this.props;
    if (!isOpen) return null;

    return ReactDOM.createPortal(
      <div className="cabinet-switcher-overlay" onClick={onClose}>
        <div
          className="cabinet-switcher-popup"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="cabinet-switcher-image-container">
            <img
              className="cabinet-switcher-img"
              src={Drawer}
              alt="Cabinet Switcher"
              loading="lazy"
            />
            <Link
              to="/welcome"
              className="cabinet-switcher-btn recordings-btn"
              aria-label="My Recordings Cabinet"
              onClick={onClose}
            />
            <Link
              to="/outtakes-home"
              className="cabinet-switcher-btn outtakes-btn"
              aria-label="Outtakes Cabinet"
              onClick={onClose}
            />
            <Link
              to="/friends-and-family-home"
              className="cabinet-switcher-btn friends-family-btn"
              aria-label="Friends & Family Cabinet"
              onClick={onClose}
            />
            <Link
              to="/playlists-home"
              className="cabinet-switcher-btn playlists-btn"
              aria-label="Playlists Cabinet"
              onClick={onClose}
            />
          </div>
        </div>
      </div>,
      document.body
    );
  }
}
